/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { WifiMode } from './models';
import { WifiProtocol } from './models';
import { WifiSSIDVisibility } from './models';
import { WifiKeyVisibility } from './models';
import { AbstractService, ServiceCallType } from '@iotize/tap';

export class WifiService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get Wi-Fi mode
   *
   * LWM2M path: /1024//15
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getMode(): Promise<TapResponse<WifiMode>> {
    return this.serviceCallRunner.execute(this.getModeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//15
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getModeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getMode };

    return callOptions;
  }

  /**
   * Write Wi-Fi mode
   *
   * LWM2M path: /1024//15
   *
   * @tapVersion(">=1.0")
   * @param mode input
   * @return
   */
  putMode(
    /*
     *
     */
    mode: WifiMode,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putModeCall(mode));
  }

  /**
   *
   *
   * LWM2M path: /1024//15
   *
   * @tapVersion(">=1.0")
   * @param mode input
   * @return call options
   */
  putModeCall(
    /*
     *
     */
    mode: WifiMode,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putMode };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get Wi-Fi key
   *
   * LWM2M path: /1024//16
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getKey(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getKeyCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//16
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getKeyCall(): ServiceCallType {
    const callOptions = { ...this.resources.getKey };

    return callOptions;
  }

  /**
   * Write network key
   *
   * LWM2M path: /1024//16
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putKey(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putKeyCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//16
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putKeyCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putKey };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get Wi-Fi hostname
   *
   * LWM2M path: /1024//35
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getHostname(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getHostnameCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//35
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getHostnameCall(): ServiceCallType {
    const callOptions = { ...this.resources.getHostname };

    return callOptions;
  }

  /**
   * Get IoTize device ip on the network
   *
   * LWM2M path: /1024//30
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getIp(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getIpCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//30
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getIpCall(): ServiceCallType {
    const callOptions = { ...this.resources.getIp };

    return callOptions;
  }

  /**
   * Write Tap IP
   *
   * LWM2M path: /1024//30
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putIp(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putIpCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//30
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putIpCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putIp };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get gateway ip on the network
   *
   * LWM2M path: /1024//31
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getGatewayIp(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getGatewayIpCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//31
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getGatewayIpCall(): ServiceCallType {
    const callOptions = { ...this.resources.getGatewayIp };

    return callOptions;
  }

  /**
   * Write gateway ip
   *
   * LWM2M path: /1024//31
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putGatewayIp(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putGatewayIpCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//31
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putGatewayIpCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putGatewayIp };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get network ip mask
   *
   * LWM2M path: /1024//32
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getIpMask(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getIpMaskCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//32
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getIpMaskCall(): ServiceCallType {
    const callOptions = { ...this.resources.getIpMask };

    return callOptions;
  }

  /**
   * Write network ip mask
   *
   * LWM2M path: /1024//32
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putIpMask(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putIpMaskCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//32
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putIpMaskCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putIpMask };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get network dns ip
   *
   * LWM2M path: /1024//124
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getDnsIp(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getDnsIpCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//124
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getDnsIpCall(): ServiceCallType {
    const callOptions = { ...this.resources.getDnsIp };

    return callOptions;
  }

  /**
   * Write network dns ip
   *
   * LWM2M path: /1024//124
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putDnsIp(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putDnsIpCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//124
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putDnsIpCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putDnsIp };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get Wi-Fi ssid
   *
   * LWM2M path: /1024//25
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getSSID(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getSSIDCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//25
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getSSIDCall(): ServiceCallType {
    const callOptions = { ...this.resources.getSSID };

    return callOptions;
  }

  /**
   * Write Wi-Fi ssid
   *
   * LWM2M path: /1024//25
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return
   */
  putSSID(
    /*
     *
     */
    key: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putSSIDCall(key));
  }

  /**
   *
   *
   * LWM2M path: /1024//25
   *
   * @tapVersion(">=1.0")
   * @param key input
   * @return call options
   */
  putSSIDCall(
    /*
     *
     */
    key: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putSSID };

    callOptions.body = key;

    return callOptions;
  }

  /**
   * Get Wi-Fi country code
   *
   * LWM2M path: /1024//95
   *
   * @tapVersion(">=1.88")
   * @return
   */
  getCountryCode(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getCountryCodeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//95
   *
   * @tapVersion(">=1.88")
   * @return call options
   */
  getCountryCodeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getCountryCode };

    return callOptions;
  }

  /**
   * Write Wi-Fi country code
   *
   * LWM2M path: /1024//95
   *
   * @tapVersion(">=1.88")
   * @param countryCode input
   * @return
   */
  putCountryCode(
    /*
     * ISO 3166 codes
     */
    countryCode: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putCountryCodeCall(countryCode));
  }

  /**
   *
   *
   * LWM2M path: /1024//95
   *
   * @tapVersion(">=1.88")
   * @param countryCode input
   * @return call options
   */
  putCountryCodeCall(
    /*
     * ISO 3166 codes
     */
    countryCode: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putCountryCode };

    callOptions.body = countryCode;

    return callOptions;
  }

  /**
   * Get Wi-Fi protocol
   *
   * LWM2M path: /1024//96
   *
   * @tapVersion(">=1.88")
   * @return
   */
  getProtocol(): Promise<TapResponse<WifiProtocol>> {
    return this.serviceCallRunner.execute(this.getProtocolCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//96
   *
   * @tapVersion(">=1.88")
   * @return call options
   */
  getProtocolCall(): ServiceCallType {
    const callOptions = { ...this.resources.getProtocol };

    return callOptions;
  }

  /**
   * Write Wi-Fi protocol
   *
   * LWM2M path: /1024//96
   *
   * @tapVersion(">=1.88")
   * @param protocol input
   * @return
   */
  putProtocol(
    /*
     *
     */
    protocol: WifiProtocol[],
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putProtocolCall(protocol));
  }

  /**
   *
   *
   * LWM2M path: /1024//96
   *
   * @tapVersion(">=1.88")
   * @param protocol input
   * @return call options
   */
  putProtocolCall(
    /*
     *
     */
    protocol: WifiProtocol[],
  ): ServiceCallType {
    const callOptions = { ...this.resources.putProtocol };

    callOptions.body = protocol;

    return callOptions;
  }

  /**
   * Get Wi-Fi TX max power
   *
   * LWM2M path: /1024//97
   *
   * @tapVersion(">=1.88")
   * @return
   */
  getTxPower(): Promise<TapResponse<number>> {
    return this.serviceCallRunner.execute(this.getTxPowerCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//97
   *
   * @tapVersion(">=1.88")
   * @return call options
   */
  getTxPowerCall(): ServiceCallType {
    const callOptions = { ...this.resources.getTxPower };

    return callOptions;
  }

  /**
   * Write Wi-Fi TX max power
   *
   * LWM2M path: /1024//97
   *
   * @tapVersion(">=1.88")
   * @param maxPower input
   * @return
   */
  putTxPower(
    /*
     *
     */
    maxPower: number,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putTxPowerCall(maxPower));
  }

  /**
   *
   *
   * LWM2M path: /1024//97
   *
   * @tapVersion(">=1.88")
   * @param maxPower input
   * @return call options
   */
  putTxPowerCall(
    /*
     *
     */
    maxPower: number,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putTxPower };

    callOptions.body = maxPower;

    return callOptions;
  }

  /**
   * Get Wi-Fi SSID visibility
   *
   * LWM2M path: /1024//98
   *
   * @tapVersion(">=1.88")
   * @return
   */
  getSSIDVisibility(): Promise<TapResponse<WifiSSIDVisibility>> {
    return this.serviceCallRunner.execute(this.getSSIDVisibilityCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//98
   *
   * @tapVersion(">=1.88")
   * @return call options
   */
  getSSIDVisibilityCall(): ServiceCallType {
    const callOptions = { ...this.resources.getSSIDVisibility };

    return callOptions;
  }

  /**
   * Write Wi-Fi SSID visibility
   *
   * LWM2M path: /1024//98
   *
   * @tapVersion(">=1.88")
   * @param visibility input
   * @return
   */
  putSSIDVisibility(
    /*
     *
     */
    visibility: WifiSSIDVisibility,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putSSIDVisibilityCall(visibility),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//98
   *
   * @tapVersion(">=1.88")
   * @param visibility input
   * @return call options
   */
  putSSIDVisibilityCall(
    /*
     *
     */
    visibility: WifiSSIDVisibility,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putSSIDVisibility };

    callOptions.body = visibility;

    return callOptions;
  }

  /**
   * Get Wi-Fi key visibility
   *
   * LWM2M path: /1024//99
   *
   * @tapVersion(">=1.88")
   * @return
   */
  getKeyVisibility(): Promise<TapResponse<WifiKeyVisibility>> {
    return this.serviceCallRunner.execute(this.getKeyVisibilityCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//99
   *
   * @tapVersion(">=1.88")
   * @return call options
   */
  getKeyVisibilityCall(): ServiceCallType {
    const callOptions = { ...this.resources.getKeyVisibility };

    return callOptions;
  }

  /**
   * Write Wi-Fi key visibility
   *
   * LWM2M path: /1024//99
   *
   * @tapVersion(">=1.88")
   * @param visibility input
   * @return
   */
  putKeyVisibility(
    /*
     *
     */
    visibility: WifiKeyVisibility,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(
      this.putKeyVisibilityCall(visibility),
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//99
   *
   * @tapVersion(">=1.88")
   * @param visibility input
   * @return call options
   */
  putKeyVisibilityCall(
    /*
     *
     */
    visibility: WifiKeyVisibility,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putKeyVisibility };

    callOptions.body = visibility;

    return callOptions;
  }

  /**
   * Get Wi-Fi network mode
   *
   * LWM2M path: /1024//128
   *
   * @tapVersion(">=2.13")
   * @return
   */
  getNetworkMode(): Promise<TapResponse<WifiMode>> {
    return this.serviceCallRunner.execute(this.getNetworkModeCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//128
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  getNetworkModeCall(): ServiceCallType {
    const callOptions = { ...this.resources.getNetworkMode };

    return callOptions;
  }

  /**
   * Write Wi-Fi network mode
   *
   * LWM2M path: /1024//128
   *
   * @tapVersion(">=2.13")
   * @param mode input
   * @return
   */
  putNetworkMode(
    /*
     *
     */
    mode: WifiMode,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putNetworkModeCall(mode));
  }

  /**
   *
   *
   * LWM2M path: /1024//128
   *
   * @tapVersion(">=2.13")
   * @param mode input
   * @return call options
   */
  putNetworkModeCall(
    /*
     *
     */
    mode: WifiMode,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putNetworkMode };

    callOptions.body = mode;

    return callOptions;
  }

  /**
   * Get Wi-Fi disable status
   *
   * LWM2M path: /1024//129
   *
   * @tapVersion(">=2.13")
   * @return
   */
  getDisabled(): Promise<TapResponse<boolean>> {
    return this.serviceCallRunner.execute(this.getDisabledCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//129
   *
   * @tapVersion(">=2.13")
   * @return call options
   */
  getDisabledCall(): ServiceCallType {
    const callOptions = { ...this.resources.getDisabled };

    return callOptions;
  }

  /**
   * Write Wi-Fi disable status
   *
   * LWM2M path: /1024//129
   *
   * @tapVersion(">=2.13")
   * @param isDisabled input
   * @return
   */
  putDisabled(
    /*
     * true to disabled wifi
     */
    isDisabled: boolean,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putDisabledCall(isDisabled));
  }

  /**
   *
   *
   * LWM2M path: /1024//129
   *
   * @tapVersion(">=2.13")
   * @param isDisabled input
   * @return call options
   */
  putDisabledCall(
    /*
     * true to disabled wifi
     */
    isDisabled: boolean,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putDisabled };

    callOptions.body = isDisabled;

    return callOptions;
  }
}
